import React from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react'
import versionJson from '@src/version.json';
import { bugsnagBreadcrumbFilter, bugsnagNoiseFilter, redactAuthParams } from './bugsnagFilters';
//import BugsnagPerformance from '@bugsnag/browser-performance'

// Same window checks as checkInTeams in @hooks/useTeams, inlined because importing that module
// pulls in @microsoft/teams-js, which touches window at import time and breaks the SSR build.
const isInTeams = () =>
  typeof window !== 'undefined' &&
  ((window.parent === window.self && (window as any).nativeInterface) ||
    window.name === 'embedded-page-container' ||
    window.name === 'extension-tab-frame');

// demo.attender.dk / demo.attender.com - checked by hostname as well, in case a demo build is made
// without NEXT_PUBLIC_IS_DEMO.
const isDemo = () =>
  process.env.NEXT_PUBLIC_IS_DEMO === 'true' ||
  (typeof window !== 'undefined' && window.location.hostname.startsWith('demo.'));

// dev/mobile are baked in at build time; Teams runs the web build, so it's detected at runtime.
const getReleaseType = () => {
  if (process.env.ENV === 'DEV') return 'dev';
  if (process.env.NEXT_PUBLIC_IS_MOBILE === 'true') return 'mobile';
  if (isDemo()) return 'demo';
  if (isInTeams()) return 'teams';
  return 'web';
};

Bugsnag.start({
  apiKey: 'f05935b45b2318e5a2b7ae6c60e5978c',
  appVersion: versionJson.version + '-' + getReleaseType(),
  plugins: [new BugsnagPluginReact()],
  // `next dev` sets NODE_ENV=development; every build (including the DEV deploy) is production.
  // Local runs still start Bugsnag so notify/breadcrumb calls work, but send nothing.
  releaseStage: process.env.NODE_ENV,
  enabledReleaseStages: ['production'],
  // Drops stackless network-failure and ResizeObserver-loop noise and lowers React hydration errors to
  // info - see bugsnagFilters.ts. The page URL can still hold MSAL's #code=... right after login.
  onError: (event) => {
    if (event.request?.url) event.request.url = redactAuthParams(event.request.url);
    if (event.context) event.context = redactAuthParams(event.context);
    return bugsnagNoiseFilter(event as any);
  },
  // Login codes / session ids out of the navigation breadcrumbs - see bugsnagFilters.ts.
  onBreadcrumb: (breadcrumb) => bugsnagBreadcrumbFilter(breadcrumb as any),
})
//BugsnagPerformance.start({ apiKey: 'f05935b45b2318e5a2b7ae6c60e5978c' })

export default Bugsnag;